import React, {memo, useMemo} from "react"
import s from "./headerNotification.module.scss"
import {BsBell} from "react-icons/bs"

type PropsType = { count?: number | undefined }
export const BellIcon: React.FC<PropsType> = memo(({count: origin}) => {
    const count = useMemo(() => {
        if (typeof origin === 'number') {
            return origin < 999 ? origin : `${origin.toString().slice(0, 2)}..`
        }
        return null
    }, [origin])

    return (
        <div className={s.bellIcon}>
            <BsBell size={26}/>
            {count ? <span className={s.bellIndicator}>{count}</span> : null}
        </div>
    )
})
